import {useTranslations} from 'next-intl';
import {
  EmailIcon,
  EmailShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

interface Props {
  referralCode: string;
  firstOrderDiscount: number;
}

export default function Share(props: Props): JSX.Element {
  const t = useTranslations('loyalty');

  const whatsapp = (
    <WhatsappShareButton
      url="de.winelivery.com"
      title={t('wallet.referral.share.whatsapp', {
        referralCode: props.referralCode,
        firstOrderDiscount: props.firstOrderDiscount,
      })}
      className="tw-inline-flex tw-flex-col tw-items-center"
    >
      <WhatsappIcon round={true} size={60} className="tw-mb-1" />
      Whatsapp
    </WhatsappShareButton>
  );

  const email = (
    <EmailShareButton
      url="de.winelivery.com"
      subject={t('wallet.referral.share.emailSubject')}
      body={t('wallet.referral.share.emailBody', {
        referralCode: props.referralCode,
        firstOrderDiscount: props.firstOrderDiscount,
      })}
      className="tw-inline-flex tw-flex-col tw-items-center"
    >
      <EmailIcon
        round={true}
        size={60}
        bgStyle={{fill: '#ffcc66'}}
        className="tw-mb-1"
      />
      Email
    </EmailShareButton>
  );

  const telegram = (
    <TelegramShareButton
      url="de.winelivery.com"
      title={t('wallet.referral.share.telegram', {
        referralCode: props.referralCode,
        firstOrderDiscount: props.firstOrderDiscount,
      })}
      className="tw-inline-flex tw-flex-col tw-items-center"
    >
      <TelegramIcon round={true} size={60} className="tw-mb-1" />
      Telegram
    </TelegramShareButton>
  );

  return (
    <div>
      <h3 className="tw-mb-3 tw-mt-4 tw-text-xl tw-text-center tw-text-gray-500">
        {t('wallet.referral.share.title')}
      </h3>
      <div className="tw-space-x-6 tw-text-center">
        {whatsapp}
        {telegram}
        {email}
      </div>
    </div>
  );
}
